import {numUtil} from './num';

const formatDate = (t) => {
  const time = new Date(t);
  const y = time.getFullYear();
  const m = time.getMonth() + 1;
  const d = time.getDate();
  return [y, m, d].map(numUtil.pad).join('-');
};

function formatDateWithSlashes(t) {
  const time = new Date(t);
  const y = time.getFullYear();
  const m = time.getMonth() + 1;
  const d = time.getDate();
  return [y, m, d].map(numUtil.pad).join('/');
}

const formatTime = (t) => {
  const time = new Date(t);
  const h = time.getHours();
  const m = time.getMinutes();
  const s = time.getSeconds();
  return [h, m, s].map(numUtil.pad).join(':');
};

const formatMonthDay = (t) => {
  const time = new Date(t);
  const m = time.getMonth() + 1;
  const d = time.getDate();
  return [m, d].map(numUtil.pad).join('-');
};

const formatMonthDayTime = (t) => {
  return [formatMonthDay(t), formatTime(t)].join(' ');
};

const formatDateTime = (t) => {
  return [formatDate(t), formatTime(t)].join(' ');
};

function formatDateTimeSlash(t) {
  return [formatDateWithSlashes(t), formatTime(t)].join(' ');
}

const formatUTCDate = (t) => {
  const time = new Date(t);
  const y = time.getUTCFullYear();
  const m = time.getUTCMonth() + 1;
  const d = time.getUTCDate();
  return [y, m, d].map(numUtil.pad).join('-');
};

const formatUTCTime = (t) => {
  const time = new Date(t);
  const h = time.getUTCHours();
  const m = time.getUTCMinutes();
  const s = time.getUTCSeconds();
  return [h, m, s].map(numUtil.pad).join(':');
};

function getTodayZeroTime() {
  const now = Date.now();
  const oneDay = 1000 * 60 * 60 * 24;
  const timezoneOffset = new Date().getTimezoneOffset() / 60;
  return now - ((now - timezoneOffset) % oneDay);
}

function getTodayUTCZeroTime() {
  const now = Date.now();
  const oneDay = 1000 * 60 * 60 * 24;
  return now - (now % oneDay);
}

const formatDiffTime = (diff: number): string => {
  diff = diff / 1e3;
  const d = Math.floor(diff / 3600 / 24);
  const h = Math.floor((diff - d * 3600 * 24) / 3600);
  return `${d}d ${h}h`;
};

export const timeUtil = {
  formatDate,
  formatDateWithSlashes,
  formatMonthDayTime,
  formatTime,
  formatDateTime,
  formatDateTimeSlash,
  formatUTCDate,
  formatUTCTime,
  getTodayZeroTime,
  getTodayUTCZeroTime,
  formatDiffTime,
};
